export function reverseBits16(n: number) {
  n = ((n & 0xff00) >> 8) | ((n & 0x00ff) << 8);
  n = ((n & 0xf0f0) >> 4) | ((n & 0x0f0f) << 4);
  n = ((n & 0xcccc) >> 2) | ((n & 0x3333) << 2);
  n = ((n & 0xaaaa) >> 1) | ((n & 0x5555) << 1);
  return n;
}
